export default "__VITE_ASSET__DPp85uci__"